export const DialogTexts = {
  Title: _TL_('Opting out may impact your auto-bidding performance'),
  Body: _TL_('If you use an auto-bidding strategy, opting out will result in these conversions no longer factoring into your bid strategy’s calculations. The conversion data for this goal will now only appear in the All conv. columns in the data table.'),
  LearnMore: _TL_('Learn more'),
  Primary: _TL_('Okay'),
  Secondary: _TL_('Cancel'),
};
